import React, { FunctionComponent } from 'react';
import { Badge, ButtonBase, Stack, Typography } from '@mui/material';
import moment from 'moment';

import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../../../components/V2/Table/type1/TableStyles';
import {
  getFormatedDurationByMinutes,
  getShortName,
} from '../../../../../../helper';
import { IUser } from '../../../../../../store/UserSlice';
import { ITransactionLog } from '../../../../../../store/V2/TransactionLogsSlice';

interface TransactionLogTableRowProps {
  transactionLog: ITransactionLog;
  viewAdminNotes: () => void;
}

const TransactionLogTableRow: FunctionComponent<TransactionLogTableRowProps> = ({
  transactionLog,
  viewAdminNotes,
}) => {
  const date = moment(transactionLog.date);
  const userData = transactionLog.user as IUser;
  const updatedByUserData = transactionLog.updatedBy as IUser;
  const userName = getShortName(userData.firstname, userData.lastname, true);
  const updatedByUserName = updatedByUserData
    ? getShortName(
        updatedByUserData.firstname,
        updatedByUserData.lastname,
        true
      )
    : '-';

  let creditChangePrefix = '';
  let creditChangeColor;

  if (transactionLog.creditChange > 0) {
    creditChangePrefix = '+';
    creditChangeColor = 'success.main';
  } else if (transactionLog.creditChange < 0) {
    creditChangePrefix = '-';
    creditChangeColor = 'error.main';
  }

  return (
    <StyledTableRow hover key={transactionLog._id}>
      <StyledTableCell>
        <Stack>
          <Typography fontSize="14px" fontWeight={500} color="#1E293B">
            {date.format('ddd MMM DD YYYY')}
          </Typography>
          <Typography fontSize="12px" color="#94A3B8">
            {date.format('hh:mm A')}
          </Typography>
        </Stack>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          className="ellipsis-text two-lines"
        >
          {userName}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          className="ellipsis-text two-lines"
        >
          {transactionLog.description}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color={creditChangeColor}
          className="ellipsis-text two-lines"
        >
          {creditChangePrefix ? `${creditChangePrefix} ` : null}
          {getFormatedDurationByMinutes({
            minutes: Math.abs(transactionLog.creditChange),
            format: 'type1',
          })}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          className="ellipsis-text two-lines"
        >
          {getFormatedDurationByMinutes({
            minutes: transactionLog.currentBalance,
            format: 'type1',
          })}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Badge
          badgeContent={(transactionLog.adminNotes || []).length}
          color="primary"
        >
          <ButtonBase onClick={viewAdminNotes}>
            <Typography
              fontSize="14px"
              fontWeight={500}
              color="#1E293B"
              textTransform="capitalize"
              sx={{ textDecoration: 'underline' }}
            >
              View Admin Notes
            </Typography>
          </ButtonBase>
        </Badge>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          className="ellipsis-text two-lines"
        >
          {updatedByUserName}
        </Typography>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default TransactionLogTableRow;
